"use strict";exports.arrayFindIndex=function(r,n){for(var t=0;t<r.length;t=++t)if(n(r[t],t,r))return t;return-1};
//# sourceMappingURL=arrayFindIndex.cjs.map
